//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      name:'',
      password:'',
      cpassword:''
    }
  },
  created() {
    this.name = this.$route.params.name
  },
  mounted() {

  },
  methods:{
    async submit() {
      if(this.cpassword === ''){
        this.$vux.alert.show({
          title: '提示信息',
          content: '请输入密码',
        })
      } else if (this.cpassword != this.password) {
        this.$vux.alert.show({
          title: '提示信息',
          content: '两次输入密码不一致!',
        })
      } else {
        let data = 'cmd=pwd_reset'+
          '&id='+ this.$route.params.id +
          '&password='+ this.password
        this.$vux.loading.show({
          text: 'Loading'
        })
        let _this = this
        this.$http.post('https://api.abeiyun.com/www/vps.php',data).then(({data})=>{
          if(data.response == 200 ) {
            this.$vux.loading.hide()
            this.$vux.alert.show({
              title: '提示信息',
              content: data.msg,
              onHide () {

              }
            })
          }else{
            this.$vux.loading.hide()
            this.$vux.alert.show({
              title: '提示信息',
              content: data.msg,
            })
          }
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/serveroperate/resetpassword.vue